import React from 'react';
import { useSelector } from 'react-redux';
import { getProfileMenuData } from '@yme/components/Header/ProfileMenu/redux/selectors';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularLinkLevel1, RegularTextLevel3 } from '@yme/tokens/typography';
import { BLANK } from '@yme/utils/constants';
const profilePath = `/s/my-profile?tabset-b5bd8=3`;
export const DisclaimerText = ({ disclaimerLink, disclaimerText, }) => {
    const { myYamahaLink } = useSelector(getProfileMenuData);
    const myYamahaProfileLink = `${myYamahaLink}${profilePath}`;
    return (React.createElement(RegularTextLevel3, { color: colorCoreBlack300 },
        disclaimerText,
        ' ',
        React.createElement(RegularLinkLevel1, { href: myYamahaProfileLink, target: BLANK }, disclaimerLink)));
};
